import Grid from '@material-ui/core/Grid';
import ACamera from './ACamera';
import XCamera from './XCamera';
import KCamera from './KCamera';
import Clock from './Clock';
import Image from './Image';
import Image_Cover from './Image_Cover';
import { displayCelestialCoords } from '../utils/displayCelestialCoords';
import * as constants from '../utils/constants';
import './Site.css';

function Site(props) {
  if (!props.siteData || Object.values(props.siteData).length < 1) {
    return (
      <div className='site-col' onClick={() => props.onClickCallback(props.siteKey)}>
        <h2>{`${props.siteName} (${props.siteCode} - ${props.siteMPCcode})`}</h2>
        <h4>Error: no data.</h4>
      </div>
    );
  }

  const { siteData, siteName, siteCode, siteMPCcode, siteKey, timezone } = props;
  const { sitech, stamp, xstamp, cover, fish1, qstat, recent, krecent, xrecent, weather } = siteData;
  const { ra_deg, dec_deg } = sitech;

  const stampImg = constants.SERVER_URL + stamp;
  const xStampImg = constants.SERVER_URL + xstamp;
  const coverImg = constants.SERVER_URL + cover;
  const fisheyeImg = constants.DASH_URL + fish1;

  return (
    <div className='site-col' onClick={() => props.onClickCallback(siteKey)}>
      <div className='site-common'>
        <h2>{`${siteName} (${siteCode} - ${siteMPCcode})`}</h2>
        <h4>{qstat}</h4>
        <Grid container direction='row' className="center-children">
          <p><b>{displayCelestialCoords(ra_deg,dec_deg)}</b></p>
          <Clock timezone={timezone} />
        </Grid>
        <Image_Cover
          style={{ width: '80%' }}
          imgSrc={coverImg}
          alt='map of tiles covered on current/most recent night'
        />
      </div>
      <div key='acam'>
        <ACamera
          camData={recent.length > 0 ? recent[recent.length-1] : { 'data': null }}
          siteKey={siteKey}
          imgSrc={stampImg}
        />
      </div>
      <div key='xcam'>
        <XCamera
          camData={xrecent.length > 0 ? xrecent[0] : { 'data': null }}
          siteKey={siteKey}
          imgSrc={xStampImg}
        />
      </div>
      <div key='kcam'>
        <KCamera
          camData={krecent.length > 0 ? krecent[0] : { 'data': null }}
          metStat={weather.met_desc}
          siteKey={siteKey}
          imgSrc={fisheyeImg}
        />
      </div>
    </div>
  );
};

export default Site;
